import React, { FC } from 'react'

import './BusinessInfo.scss'
const currentYear = new Date().getFullYear()
const BusinessInfo: FC = () => (
  <ul className="business-info">
    <li>
      <a className="business-info__link" href="https://www.wmg.com/">
        Warner Music Inc.
      </a>
    </li>
    <li>
      <a className="business-info__link" href="https://www.wmg.com/who-we-are">
        About Warner Music Group
      </a>
    </li>
    <li>
      <a className="business-info__link" href="https://www.wmg.com/faq">
        Help & FAQs
      </a>
    </li>
    <li>
      <a className="business-info__link" href="https://www.wmg.com/privacy-policy">
        Privacy Policy
      </a>
    </li>
    <li>
      <a className="business-info__link" href="https://www.wmg.com/terms-of-use">
        Terms & Conditions
      </a>
    </li>
    <div className="business-info__footer">
      <span className="business-info__copyright">Warner Music Group</span>
      <span className="business-info__copyright">Copyright @{currentYear}</span>
    </div>
  </ul>
)

export default BusinessInfo
